import { QpMessageTooltip } from "./qp-message-tooltip.directive";
import tooltipMoreTpl from "./tooltip-more.template.html";
import tooltipTpl from "./tooltip.template.html";
import "./index.less";

let module_name = "qp-message-tooltip"

angular.module(module_name, [])
    .directive({
        qpMsgTooltip: QpMessageTooltip
    })
    .run(["$templateCache", function ($templateCache: angular.ITemplateCacheService) {
        $templateCache.put("tooltip.template.html", tooltipTpl);
        $templateCache.put("tooltip-more.template.html", tooltipMoreTpl);
    }])

export { module_name }
